/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Description_PlaceholderInputs */

const en_job_form_description_placeholder = /** @type {(inputs: Job_Form_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tasks, requirements, etc.`)
};

const de_job_form_description_placeholder = /** @type {(inputs: Job_Form_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufgaben, Anforderungen, etc.`)
};

/**
* | output |
* | --- |
* | "Tasks, requirements, etc." |
*
* @param {Job_Form_Description_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const job_form_description_placeholder = /** @type {((inputs?: Job_Form_Description_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Description_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_description_placeholder(inputs)
	return en_job_form_description_placeholder(inputs)
});